import Api from '@/services/Api'

export default {
    getVigenciaCargue(){
        return Api().get('cargue/vigenciaCargue')
    },
    cargaBalace(form){
        return Api().post('cargue/cargaBalance', form)
    },
    cargaIntercoF10(form) {
        return Api().post('cargue/cargaIntercoF10', form)
    },
    cargaIntercoF20(form) {
        return Api().post('cargue/cargaIntercoF20', form)
    },
    cargaIntercoF30(form) {
        return Api().post('cargue/cargaIntercoF30', form)
    },
    cargaIntercoF40(form) {
        return Api().post('cargue/cargaIntercoF40', form)
    },
    cargaIntercoF50(form) {
        return Api().post('cargue/cargaIntercoF50', form)
    },
    cargaIntercoF60(form) {
        return Api().post('cargue/cargaIntercoF60', form)
    },
    cargaBalaceF2(form){
        return Api().post('cargue/cargaBalanceF2', form)
    },
    cargaBalaceF3(form){
        return Api().post('cargue/cargaBalanceF3', form)
    },
    cargaBalaceF4(form){
        return Api().post('cargue/cargaBalanceF4', form)
    },
    cargaBalaceF5(form){
        return Api().post('cargue/cargaBalanceF5', form)
    },
    cargaBalaceF6(form){
        return Api().post('cargue/cargaBalanceF6', form)
    },
    cargaBalaceF7(form){
        return Api().post('cargue/cargaBalanceF7', form)
    },
    cargaBalaceF8(form){
        return Api().post('cargue/cargaBalanceF8', form)
    },
    cargaBalaceF9(form){
        return Api().post('cargue/cargaBalanceF9', form)
    },
    cargaBalaceF10(form){
        return Api().post('cargue/cargaBalanceF10', form)
    },
    cargaBalaceF100(form){
        return Api().post('cargue/cargaBalanceF100', form)
    },
    cargaBalaceF200(form){
        return Api().post('cargue/cargaBalanceF200', form)
    },
    cargaBalaceF300(form){
        return Api().post('cargue/cargaBalanceF300', form)
    },
    cargaBalaceF400(form){
        return Api().post('cargue/cargaBalanceF400', form)
    },
    cargaBalaceF500(form){
        return Api().post('cargue/cargaBalanceF500', form)
    },
    cargaBalaceF600(form){
        return Api().post('cargue/cargaBalanceF600', form)
    },
    actualizaNiif(p_vigencia,p_compania){
        return Api().get('actualizaNiif/'+p_vigencia+'/'+p_compania)
    },
    getFormatosInterco() {
        return Api().get('/cargue/formatos-interco')
    },
	calculaCTA(selVigencia,companyId,userId) {
		return Api().post('/cargue/calculaCTA/'+selVigencia+'/'+companyId+'/'+userId)
	},
    getHistorialCargas() {
        return Api().get('cargue/historial')
    },
}
